import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  { label: "Usage", to: "/analytics/usage", enabled: true },
  { label: "Query Logs", to: "/analytics/query-logs", enabled: true },
  {
    label: "Document Performance",
    to: "/analytics/document-performance",
    enabled: true,
  },
  { label: "Gap Analysis", to: "/analytics/gap-analysis", enabled: true },
  { label: "Audit Log", to: "/analytics/audit-log", enabled: true },
];

export function AnalyticsLayout() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-serif text-3xl font-normal tracking-[-0.005em] text-[var(--text)] mb-4">
        Analytics
      </h1>

      {/* Tab bar — active tab is dark text with an inset olive underline */}
      <div className="flex gap-[26px] border-b border-[var(--border)] mb-[22px]">
        {tabs.map((tab) =>
          tab.enabled ? (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `px-px pb-3 text-[13.5px] whitespace-nowrap transition-colors ${
                  isActive
                    ? "font-semibold text-[var(--text)] shadow-[inset_0_-2px_0_var(--accent)]"
                    : "font-medium text-[var(--text-3)] hover:text-[var(--text-2)]"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ) : (
            <span
              key={tab.to}
              className="px-px pb-3 text-[13.5px] font-medium text-[var(--text-faint)] cursor-not-allowed"
            >
              {tab.label}
            </span>
          ),
        )}
      </div>

      <Outlet />
    </div>
  );
}
